/**
 * Shared validation constants for field max lengths.
 * These values are mirrored in supabase/functions/_shared/validation-constants.ts
 * for server-side enforcement. Keep both files in sync.
 */
export const VALIDATION = {
  CUSTOMER_NAME_MAX: 100,
  PHONE_MAX: 20,
  ADDRESS_MAX: 500,
  COMMENTS_MAX: 1000,
  ORDER_NUMBER_MAX: 50,
  COMPANY_NAME_MAX: 200,
  MESSAGE_MAX: 1000,
  EMAIL_MAX: 255,
  CSR_NAME_MAX: 100,
  ASSIGNED_TO_MAX: 100,
  PARSED_ITEMS_MAX: 10000,
} as const;
